/** @format */

import './App.css';
import { Switch } from 'react-router-dom';
import SurveyPageTwilio from './pages/surveypage-twilio/surveypage-twilio.component';
import CustomerSupportPage from './pages/customer-support-page/customer-support-page';
import HomePage from './pages/homepage/homepage.component';
import AutomationPage from './pages/automations-page/automation-page.component';
import MaintenancePage from './pages/maintenance-page/maintenance-page.component';
import Header from './components/header/header.component';
import PublicRoute from './components/public-route/public-route.component';
import PrivateRoute from './components/private-route/private-route.component';
import NewHirePage from './pages/newhire-page/newhire-page.component';
import TerminationPage from './pages/termination-page/termination-page.component';
// import SecurityPage from './pages/security-page/security.component';
import SessionTimeout from './components/session-timeout/session-timeout.component';
import WirepasPage from './pages/wirepas-page/wirepas.page';
import ValetPage from './pages/valet-page/valet-page.component';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { signOutStart, checkUserSession } from './redux/user/user.actions';
import { selectCurrentUser } from './redux/user/user.selector';
import React, { useEffect } from 'react';

// import { persistor } from './redux/store';

import { Container, Box } from '@mui/material';
// import { logoutSignal } from './utils/logout-signal';
// import useWindowDimensions from './utils/useWindowDimensions.hook';
const App = ({ checkUserSession, signOut, currentUser }) => {
  // const { width } = useWindowDimensions();
  useEffect(() => {
    checkUserSession();
  }, [checkUserSession]);

  useEffect(() => {
    const handleTabClose = async (event) => {
      event.preventDefault();
      if (currentUser) {
        // await signOut();
        // await persistor.purge();
        alert('Please sign out before closing the tab.');
      }

      return (event.returnValue = 'You have been signed out.');
    };

    window.addEventListener('beforeunload', handleTabClose);

    return () => {
      window.removeEventListener('beforeunload', handleTabClose);
    };
  }, [currentUser, signOut]);

  return (
    <Container maxWidth="xl" disableGutters sx={{ minWidth: `100vw` }}>
      <SessionTimeout />

      <Header />
      <Box className="App-header">
        {/*  */}
        <Switch>
          <PublicRoute component={HomePage} path="/" exact />
          {/* <PrivateRoute
            component={SecurityPage}
            roles={['admin', 'security', 'ms']}
            path="/security"
            exact
          /> */}
          <PrivateRoute
            component={SurveyPageTwilio}
            roles={['admin', 'coordinator', 'occCS']}
            path="/twilio"
            exact
          />
          <PrivateRoute
            path="/customerSupport"
            roles={['admin', 'customerSupport', 'occCS', 'ms']}
            component={CustomerSupportPage}
          />

          <PrivateRoute
            path="/wirepas"
            roles={['admin', 'guest']}
            component={WirepasPage}
            exact
          />

          <PrivateRoute
            path="/automations/newhire/"
            roles={['admin']}
            component={NewHirePage}
          />
          <PrivateRoute
            path="/automations/termination/"
            roles={['admin']}
            component={TerminationPage}
          />
          <PrivateRoute
            path="/automations"
            roles={['admin']}
            component={AutomationPage}
          />
          <PrivateRoute
            path="/maintenance"
            roles={['admin']}
            component={MaintenancePage}
          />
          <PrivateRoute
            path="/valet"
            roles={['admin', 'valet']}
            component={ValetPage}
          />
        </Switch>
      </Box>
    </Container>
  );
};

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
});

const mapDispatchToProps = (dispatch) => ({
  checkUserSession: () => dispatch(checkUserSession()),
  signOut: () => dispatch(signOutStart()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
